import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import DataTable from "../../../components/AdminTable//DataTable";
import { apiKey } from "../../../config/config";
import axios from "axios";
import { languageHelper } from "../../../config/helperFunctions";

function IngredientAlert() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: "	Ingredient(Code)",
      cell: (row) => `${row.row.original.name}(${row.row.original.code})`,
    },
    {
      header: "Category",
      cell: (row) => row.row.original?.ingredient_category?.category_name,
    },
    {
      header: "	Stock Qty/Amount",
      cell: (row) =>
        `${row.row.original.stock_value.toFixed(2)} ${
          row.row.original.ingredient_unit?.unit_name || ""
        }`,
    },
    {
      header: "Alert Qty/Amount",
      cell: (row) =>
        `${row.row.original.alert_quantity} ${
          row.row.original.ingredient_unit?.unit_name || ""
        }`,
    },
  ];
  const [data, setData] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/get-inventory`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        params: {
          outletId: user?.user?.outlet_id,
          is_alert: 1,
        },
      })
      .then((res) => {
        setData(res.data.inventory);
      });
  }, [user.token, user?.user?.outlet_id]);
  return (
    <main>
      <div className="text-d-bg-text text-3xl text-center mb-4 mt-8">
        {languageHelper("Alert Inventory")}
      </div>
      <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>

      <button
        className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
        type="button"
        onClick={() => navigate(-1)}
      >
        {languageHelper("Back")}
      </button>

      <DataTable columns={columns} data={data} />
    </main>
  );
}

export default IngredientAlert;
